import './input.min.js'
import './toast.js'
import './popover.js'
import './combobox.js'
import './collapse.js'
import './accordion.js'
import {registerFilterModal} from './filterModal.js'
import {hxConfirm} from './confirm.js'
import {downloadAuthed} from './download.js'
import {getEl, getAllEl, domIsSettled, removeElementByID, formatNumber} from './dom.js'
import { TinyGesture } from './tinygesture.js'

window.hxConfirm = hxConfirm
window.downloadAuthed = downloadAuthed
window.removeElementByID = removeElementByID

window.$ = getEl
window.$$ = getAllEl
window.formatNumber = formatNumber
window.TinyGesture = TinyGesture

document.addEventListener('alpine:init', () => {
	if (window.Alpine) {
		registerFilterModal();
		window.Alpine.directive('gesture', (el, directive, utilities) => {
			const expression = directive.expression;
			const modifiers = directive.modifiers;
			const evaluateLater = utilities.evaluateLater;
			const effect = utilities.effect;

			const gesture = new TinyGesture(el, { mouseSupport: true });
			const evaluate = evaluateLater(expression);

			if (modifiers.includes('swipeleft')) {
				let startX = 0;
				let origTransform = el.style.transform || '';

				el.addEventListener('touchstart', (e) => {
					startX = e.touches[0].clientX;
					el.style.transition = 'none';
				}, { passive: true });

				el.addEventListener('touchmove', (e) => {
					let diff = e.touches[0].clientX - startX;
					if (diff < 0) {
						el.style.transform = `translateX(${Math.max(-100, diff)}px)`;
					}
				}, { passive: true });

				el.addEventListener('touchend', () => {
					el.style.transition = 'transform 0.2s cubic-bezier(0.2, 0.8, 0.2, 1)';
					el.style.transform = origTransform;
				}, { passive: true });

				gesture.on('swipeleft', (e) => {
					evaluate();
				});
			}

			if (modifiers.includes('longpress')) {
				gesture.on('longpress', (e) => {
					evaluate();
				});
			}
		});
	}
});

window.openDialog = openDialog
export function openDialog(id) {
	domIsSettled().then(() => {
		const $el = document.querySelector(`#${id}`)
		if ($el) {
			$el.showModal()
		}
	})
}
